import request from '@/utils/request'

// 查询列表
export function apiScpApsAbnormalityList (query) {
  return request({
    url: '/scp/scpApsAbnormality/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpApsAbnormalityNewExport (data) {
  return request({
    url: '/scp/scpApsAbnormality/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiScpApsAbnormalityUpdate (data) {
  return request({
    url: '/scp/scpApsAbnormality',
    method: 'put',
    data: data
  })
}

// 新增
export function apiScpApsAbnormalityAdd (data) {
  return request({
    url: '/scp/scpApsAbnormality',
    method: 'post',
    data: data
  })
}

// 删除
export function apiScpApsAbnormalityDelete (id) {
  return request({
    url: `/scp/scpApsAbnormality/${id}`,
    method: 'delete'
  })
}

// 车间编码
export function apiBomWorkshopFindList (query) {
  return request({
    url: '/bom/bomWorkshop/findList',
    method: 'get',
    params: query
  })
}

// 产线编码
export function apiBomProdLineFindList (query) {
  return request({
    url: '/bom/bomProdLine/findList',
    method: 'get',
    params: query
  })
}
